export enum BadgeStatus {
  Current = "Current",
  Pending = "Pending",
  "Pending Renewal" = "Pending Renewal",
  "Pending Transfer" = "Pending Transfer",
  "Under Eviction" = "Under Eviction",
  enrolled = "Enrolled",
  not_enrolled = "Not enrolled",
  unenrolled = "Unenrolled",
  error = "Error",
  under_review = "Under review",
  invited = "Invited",
  inactive = "Inactive",
  opted_out = "Opted out",
  registered = "Registered",
  rejected = "Rejected",
  active = "Active",
  pending_customer_action = "Pending customer action",
  up_to_date = "Up to date",
  not_applicable = "Not applicable",
  verification_needed = "Verification needed",
  open = "Open",
  paid = "Paid",
  pending = "Pending",
  // Onboarding statuses
  approved = "Approved",
  Rejected = "Rejected",
  _pending = "Pending",
  finished = "Finished",
  review_required = "Under review"
}
